import React from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "./contexts/LanguageContext";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import AppRoutes from "./components/AppRoutes";
import { ScrollProgress } from "./components/ScrollProgress";
import { MobileContactBar } from "./components/MobileContactBar";

function App() {
  return (
    <HelmetProvider>
    <LanguageProvider>
      <MotionConfig reducedMotion="user">
        <BrowserRouter>
          <div className="App pb-[84px] md:pb-0">
            <ScrollProgress />
            <Navbar />
            <AppRoutes />
            <Footer />
            <MobileContactBar />
            <Toaster position="top-right" />
          </div>
        </BrowserRouter>
      </MotionConfig>
    </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
